import { render, staticRenderFns } from "./DashboardGudang.vue?vue&type=template&id=ad596666&scoped=true&"
import script from "./DashboardGudang.vue?vue&type=script&lang=js&"
export * from "./DashboardGudang.vue?vue&type=script&lang=js&"
import style0 from "./DashboardGudang.vue?vue&type=style&index=0&id=ad596666&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad596666",
  null
  
)

export default component.exports